import React from "react";
import { HelpBlock } from "components/bootstrap";
const ValidationErrors = ({ errors = void 0 }) => {
  if (!errors || errors.length === 0) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, errors.map((error) => /* @__PURE__ */ React.createElement(HelpBlock, { key: error }, error)));
};
export default ValidationErrors;
